const ScreenShareHook = {
  mounted() {
    this._frameCount = 0;
    this._counterEl = document.getElementById("ss-frame-count");

    this.handleEvent("screen_frame", ({ data }) => {
      // Setting img.src keeps the previous image visible until the new JPEG
      // is fully decoded by the browser — no black flash between frames.
      this.el.src = `data:image/jpeg;base64,${data}`;

      // Update frame counter directly in the DOM — no LiveView re-render needed
      this._frameCount += 1;
      if (this._counterEl) {
        this._counterEl.textContent = `${this._frameCount} frames`;
      }
    });
  },

  destroyed() {
    this._frameCount = 0;
  }
};

export default ScreenShareHook;
